import "../../shimmer.css";

const ChannelPreferanceShimmer = ({ last }) => {
  return (
    <div
      className={`flex items-center gap-3 px-4 py-3.5 ${
        last ? "" : "border-b border-gray-100"
      }`}
    >
      <div className="w-9 h-9 rounded-full animate-pulse-gradient shrink-0"></div>
      <div className="flex-1 space-y-2">
        <div className="w-[150px] h-3.5 rounded-full animate-pulse-gradient"></div>
        <div className="w-[80%] h-3 rounded-full animate-pulse-gradient"></div>
      </div>
      <div className="w-[51px] h-[31px] rounded-full animate-pulse-gradient shrink-0"></div>
    </div>
  );
};

export default ChannelPreferanceShimmer;
